import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleNavClick = (item) => {
    if (item.route) {
      navigate(item.route);
      setIsMobileMenuOpen(false);
      return;
    }
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: item.id } });
      setIsMobileMenuOpen(false);
    } else {
      scrollToSection(item.id);
    }
  };

  const menuItems = [
    { label: 'Início', id: 'hero' },
    { label: 'Cardápio', id: 'menu' },
    { label: 'Menu Páscoa', route: '/pascoa' },
    { label: 'Preços', id: 'pricing' },
    { label: 'Sobre', id: 'about' },
    { label: 'Contato', id: 'contact' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-amber-50 shadow-lg py-3' 
          : 'bg-amber-50 py-5'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => location.pathname === '/' ? window.scrollTo({ top: 0, behavior: 'smooth' }) : navigate('/')}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_1d505a5f-a544-4c6e-8862-fec39bdf81d8/artifacts/gj3rnkah_image.png"
              alt="Ser Tão Doce"
              className="w-12 h-12 object-contain"
            />
            <div>
              <div className="font-bold text-amber-900 text-xl">Ser Tão Doce</div>
              <div className="text-xs text-amber-700">Waleria Mapeli</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {menuItems.map((item) => (
              <button
                key={item.route || item.id}
                onClick={() => handleNavClick(item)}
                className={`text-amber-900 hover:text-amber-700 font-medium transition-colors relative group ${
                  item.route && location.pathname === item.route ? 'text-orange-700' : ''
                }`}
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-700 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button 
              onClick={() => handleNavClick({ id: 'pricing' })}
              className="bg-amber-700 hover:bg-amber-800 text-white rounded-full px-6 transition-all duration-300 hover:scale-105"
            >
              Fazer Pedido
            </Button>
          </div>

          {/* Mobile menu button */}
          <button 
            className="lg:hidden p-2 text-amber-900"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-amber-200 pt-4">
            <div className="flex flex-col gap-3">
              {menuItems.map((item) => (
                <button
                  key={item.route || item.id}
                  onClick={() => handleNavClick(item)}
                  className="text-amber-900 hover:text-amber-700 font-medium text-left py-2 px-4 rounded-lg hover:bg-amber-50 transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <Button 
                onClick={() => handleNavClick({ id: 'pricing' })}
                className="bg-amber-700 hover:bg-amber-800 text-white rounded-full mt-2"
              >
                Fazer Pedido
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
